export interface IPolicyKey {
    id: number;
    name: string;
}

const ICON_BY_NAME: Record<string, string> = {
    app_terms: 'pi pi-file-edit',
    terms: 'pi pi-file-edit',
    app_privacy: 'pi pi-lock',
    privacy: 'pi pi-lock',
    cookies: 'pi pi-bookmark',
};

const FALLBACK_ICON = 'pi pi-file';

export class PolicyKey implements IPolicyKey {
    readonly id: number;
    readonly name: string;

    constructor(data: IPolicyKey) {
        this.id = data.id;
        this.name = data.name;
    }

    get icon(): string {
        return ICON_BY_NAME[this.name] ?? FALLBACK_ICON;
    }

    get labelKey(): string {
        return `legal.policyKey.${this.name}`;
    }

    static fromEnumeration(data: IPolicyKey): PolicyKey {
        return new PolicyKey(data);
    }
}
